var manageCareersCode = function () {

    var ManageCareersCodeModule = {
        settings: {
            codeFormId: '#generate-code-form-id',
        }
    }

    var initCommonActions = function () {

        $('.copy-clipboard').click(function () {
            //
        });

        $('.btn-submit').click(function () {

            $.post({
                url: '/get/form/upload/cv',
                success: function(data){
                    $('#common-modal-title').html(Lang.get('app-page.upload_cv'));
                    $('#common-modal-body').html(data);
                    $('#common-modal').modal('show');

                    validateRenegerateCodesForm();
                }
            });

        });

    };

    const validateRenegerateCodesForm = function (action) {

        jQuery.validator.addMethod("phoneUS", function(phone_number, element) {
            phone_number = phone_number.replace(/\s+/g, "");
            return this.optional(element) || phone_number.length > 9 &&
                phone_number.match(/^(\+?1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/);
        }, "Please specify a valid phone number");

        var btn = $(this);
        var form = $(ManageCareersCodeModule.settings.codeFormId);

        form.validate({
            ignore: "",
            errorClass: "text-danger",
            errorElement: "span",

            rules: {
                cv_first_name: {
                    required: true,
                    maxlength: 255
                },
                cv_last_name: {
                    required: true,
                    maxlength: 255
                },
                cv_phone: {
                    phoneUS: true
                },
                cv_email: {
                    required: true,
                    email: true
                },
                cv_file:{
                    required: true
                },


            },
            messages: {
                cv_first_name: {
                    required: Lang.get('js-validator-mess.required'),
                    maxlength: Lang.get('js-validator-mess.maxlength')
                },
                cv_last_name: {
                    required: Lang.get('js-validator-mess.required'),
                    maxlength: Lang.get('js-validator-mess.maxlength')
                },
                cv_phone: {
                    phoneUS: Lang.get('js-validator-mess.phoneUS')
                },
                email: {
                    required: Lang.get('js-validator-mess.required'),
                    email: Lang.get('js-validator-mess.email')
                },
                cv_file: {
                    required: Lang.get('js-validator-mess.required')
                }
            },


            highlight: function highlight(element, errorClass) {
                $(element).removeClass(errorClass);
            }
        });

        $('#sbt-common-modal').unbind("click");

        $('#sbt-common-modal').click(function (e) {
            e.preventDefault();
            btn.addClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', true);

            const form = $(ManageCareersCodeModule.settings.codeFormId);

            if (form.validate().form()) {

                $('#common-modal').modal('hide');
                initAppPage.blockUIStart(ManageCareersCodeModule.settings.contentBlock);

                $.post({
                    url: form.attr("action"),
                    data: form.serialize(),
                    success: function (data) {

                        form.submit();
                    },
                    error: function (data) {
                        console.log('Error: ', data);
                    }
                });

            }
            return false;
            btn.addClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', false);
        });

        const realFileBtn = document.getElementById("cv_file");
        const customBtn = document.getElementById("custom-button");
        const customTxt = document.getElementById("custom-text");

        customBtn.addEventListener("click", function (){
         realFileBtn.click();
        });

        realFileBtn.addEventListener("change", function (){
            if(realFileBtn.value) {
            customTxt.innerHTML = realFileBtn.value.split("\\").pop();
            }
            else {
            customTxt.innerHTML = Lang.get('careers.add_a_file')
            }
        });


    };

    return {

        //main function to initiate the module
        init: function () {
            initCommonActions();
        }

    };

}();

jQuery(document).ready(function () {
    manageCareersCode.init();
});
